function directive(Global) {
    return {
        restrict: 'A',
        transclude : false,
        link: function ($scope, element) {
            let d = new Date().getFullYear();
            let version = Global.version;
            var html = '&copy; ' + d + ' Mantix4 <br /> version: ' + version;
            element.replaceWith(html);
        }
    };
}

directive.$inject = ['Global'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/copyright/copyright.js
 **/